import React from 'react';
import {FaIcon} from "../FaIcon";
import {EditElementModal} from "../EditElementModal";
import {EditGoalForm} from "./EditGoalForm";
import { withTranslation } from 'react-i18next';

class EditGoalModalClass extends EditElementModal {
    renderModalForm() {
        return <EditGoalForm closeModal={this.toggle}
                             onModified={this.handleFormSubmitted}
                             businessUnitId={this.props.businessUnitId}
                             campaignsConfigurationId={this.props.campaignsConfigurationId}
                             campaignId={this.props.campaignId}
                             adgroupId={this.props.adgroupId}
                             priority={this.props.priority}
        />
    }

    renderButton() {
        return <button className="edit-button" onClick={this.toggle}><FaIcon iconName={"pencil-alt"}/></button>;
    }

    renderModalHeaderText() {
        const { t } = this.props;
        return t('edit_goal_modal.title');
    }
}

export const EditGoalModal = withTranslation()(EditGoalModalClass);
export default EditGoalModal;
